import React, { useState } from 'react'
import Web3 from "web3";
import { Grid, Container, makeStyles, Button, Input, Typography, Box, TextField } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel';
import { useSelector, useDispatch } from 'react-redux'
import { SaveUserAccount } from '../../redux/action/user';
import { showAlert } from '../../utils';
import history from '../../history/history'
const web3 = new Web3(Web3.givenProvider || "ws://localhost:8545");
const useStyles = makeStyles(theme => ({

  heroTextContainer: {
    paddingTop: "8rem",
    paddingBottom: "5rem",

  },
  loginform: {
    height: "20rem",
    padding: "2rem",
    justifyContent: "center",
    background: "rgba(0, 0, 0, .15)",
    borderTop: "2px solid #FF5805 ",
    textAlign: "center"
  },
  lfInput: {
    width: "100%",
    backgroundColor: "white",
    border: "0",
    color: "#314573",
    fontSize: " 1rem",
    padding: "0.5em "
  },
  labels: {
    color: "white",
    display: "flex",
    justifyContent: "flex-start",
    padding: ".5rem"
  },
  button: {
    backgroundColor: "#FF5805",
    marginTop: "1em",
    height: "3rem",
    color: "white",
    "&:hover": {
      backgroundColor: '#FF5805'
    }


  },
  flexrow: {
    marginTop: "1rem"
  }




}))



export default function Login({ useraccount }) {
  const states = useSelector(state => state.UserReducer)
  const Aut = useSelector(state => state.AutReducer)
  const [account, setAccount] = React.useState('')

  const dispatch = useDispatch()
  const [name, setName] = useState('')
  const [walletAddress, setwalletAddress] = useState(useraccount ? useraccount : account)
  const SubmitForm = (e) => {
    e.preventDefault()


    let data = {
      name,
      walletAddress: useraccount
    }


    dispatch(SaveUserAccount(data))
  }




  React.useEffect(() => {
    if (Aut?.user?.success) {
      showAlert(Aut.user.message, 'success')
      history.push('/')
    } else if (Aut?.user?.success === false) {
      showAlert(Aut.user.message, 'error')
    }
  }, [Aut.user])
  // console.log(Aut.loinAddress, "this is the ==========>")


  React.useEffect(() => {

    if (Aut.loinAddress?.find === true) {
      history.push('/dashboard')
    }

  }, [Aut.loinAddress.find])

  const classes = useStyles();
  return (
    <div style={{ backgroundColor: "#15244D" }}>
      <Container maxWidth="sm" className={classes.heroTextContainer} direction="column" >
        <Box className={classes.loginform}>
          <Box className={classes.flexrow}>
            <form onSubmit={SubmitForm}>
              <InputLabel className={classes.labels}>*Wallet Address</InputLabel>
              <Input
                className={classes.lfInput}
                color="primary"
                required
                value={useraccount}

              />
              <InputLabel className={classes.labels}>*Nick Name</InputLabel>
              <Input
                className={classes.lfInput}
                color="primary"
                required
                value={name}
                type="string"
                onChange={(e) => setName(e.target.value)}
              />
              <Button variant="outlined" type="submit" className={classes.button} fullWidth>Submit</Button>
            </form>
          </Box>
        </Box>
      </Container>
    </div>
  )
}
